import { Box, Menu, MenuItem } from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import { useAuth0 } from "@auth0/auth0-react";

export default function HamburgerButtonDropdownMenu({...params}) {

    let page = params.page
    let channelID = params.channelID
    let canEdit = params.canEdit
    let isAdmin = params.isAdmin
    let menuAnchor = params.menuAnchor
    let closeMenu = params.closeMenu
    const isMenuOpen = Boolean(menuAnchor);
   
    const { isAuthenticated, loginWithRedirect, logout } = useAuth0();
    const navigate = useNavigate();
    const location = useLocation();

    const navigateToPage = (page) => {
        closeMenu();
        navigate(page);
    };

    const handleSignIn = () => {
        closeMenu();
        loginWithRedirect();
    };

    const handleSignOut = () => {
        closeMenu();
        logout({ logoutParams: { returnTo: window.location.origin } });
    };

    const stationsAndDevPageSwap = () => {
        if(location.pathname ==="/devpage") navigate("/stationspage")
        else navigate("/devpage")
        closeMenu()
    }

    return (
        <Menu anchorEl={menuAnchor} open={isMenuOpen} onClose={closeMenu}>
            <MenuItem onClick={() => navigateToPage("/settingspage")}>
                Settings
            </MenuItem>

            {isAuthenticated ? (
                 <Box>
                    <MenuItem onClick={() => navigateToPage("/profilepage")}>Profile</MenuItem>
                    <MenuItem onClick={handleSignOut}>Sign Out</MenuItem>
                </Box>
                
            ) : (
                <MenuItem onClick={handleSignIn}>Sign In</MenuItem>
            )}

            {isAdmin && (
                <MenuItem onClick={() => navigateToPage("/adminpage")}>
                    Admin
                </MenuItem>
            )}

            {((page === "ChannelPage" || page === "EditPage") && canEdit) && (
                <MenuItem onClick={() => navigateToPage("/editpage/" + channelID)}>
                    Edit Portal
                </MenuItem>
            )}

            {(page === "StationsPage" && isAdmin) && (
                <MenuItem onClick={() => stationsAndDevPageSwap()}>
                    {location.pathname === "/devpage" ? "Basic View" : "Dev View"}
                </MenuItem>
            )} 
        </Menu>
    );
}
